<template>
  <div>
    <campo-formulario/>
  </div>
</template>

<script>
import campoFormulario from "../components/campoFormulario.vue";

export default {
  components: {
    "campo-formulario": campoFormulario
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/screens/Calculo.vue